<!-- Maintenance page overlay -->
@if (isUnderMaintenance()) {
  <app-maintenance-page [maintenanceEndTime]="maintenanceEndTime()"></app-maintenance-page>
} @else {
<!-- Global Loader -->
<app-global-loader *ngIf="!hideLoader()"></app-global-loader>

<div class="flex" style="height: 100vh; overflow: hidden;">

  <!-- Sidebar -->
  <aside class="sidebar-wrapper" *ngIf="!hideSidebar()">
    <app-sidebar></app-sidebar>
  </aside>

  <!-- Right side -->
  <div class="flex-1 flex flex-col" style="overflow: hidden; min-width: 0;">
    <app-header *ngIf="!hideHeader()"></app-header>

    <!-- Content -->
    <div class="p-4 bg-gray-100 flex-1 overflow-y-auto" style="overflow-x: hidden;">
      <router-outlet></router-outlet>
    </div>
  </div>

</div>
}